import PropTypes from 'prop-types';
import clsx from 'clsx';
import CustomText from '@components/shared/CustomText';
import CustomButton from '@components/shared/CustomButton';
import DownloadIcon from '@assets/icons/download.svg';
import FilterIcon from '@assets/icons/filter.svg';
import DotsIcon from '@assets/icons/three-dots.svg';

import DropdownComponent from '@components/DropdownComponent';
import {
  DROPDOWN_ITEMS,
  DROPDOWN_VALUES,
  SORT_ITEMS,
} from '@features/DocViewer/Steps/Docs/DocsTableHeader/constants';
import { useMemo } from 'react';
import LoaderSkeleton from '@components/LoaderSkeleton';
import styles from './DocsTableHeader.module.scss';

const DocsTableHeader = ({
  selected,
  setModalOpen,
  isDownloading,
  count,
  downloadSelected,
  onChangeSort,
  sort,
  isLoading,
}) => {
  const download_items_mapped = useMemo(() => {
    return Object.keys(selected).length > 0
      ? [
          ...DROPDOWN_ITEMS,
          {
            icon: <DownloadIcon width={16} />,
            id: DROPDOWN_VALUES.SELECTED,
            value: `${DROPDOWN_VALUES.SELECTED} (${
              Object.keys(selected).length
            })`,
          },
        ]
      : DROPDOWN_ITEMS;
  }, [selected]);

  const sort_items_mapped = useMemo(
    () =>
      SORT_ITEMS.map(value => ({
        ...value,
        isSelected: value.id === sort,
      })),
    [sort],
  );

  const handleItemClick = dropdownSelected => {
    switch (dropdownSelected.id) {
      case DROPDOWN_VALUES.ALL:
        setModalOpen(true);
        break;
      case DROPDOWN_VALUES.SELECTED:
        downloadSelected();
        break;
      default:
        break;
    }
  };
  return (
    <div className={styles.tableTitle}>
      <div>
        <CustomText customStyle={clsx('h4', styles.mainText)}>
          Your Completed Docs
        </CustomText>

        {isLoading && !count ? (
          <LoaderSkeleton height={18} width={140} />
        ) : (
          <CustomText customStyle={'subtitle2'}>{`You have ${
            count || 0
          } Docs`}</CustomText>
        )}
      </div>
      {false && (
        <>
          <div className={styles.buttons}>
            <CustomButton
              onClick={downloadSelected}
              secondary
              maxWidth={250}
              disabled={isDownloading}
              text={
                isDownloading
                  ? 'Downloading'
                  : `Download selected (${Object.keys(selected).length})`
              }
              icon={<DownloadIcon width={18} />}
              customStyle={clsx(
                styles.buttonSelected,
                !(Object.keys(selected).length > 0) && styles.hidden,
              )}
            />
            <CustomButton
              onClick={() => setModalOpen(true)}
              maxWidth={175}
              text='Download all'
              icon={<DownloadIcon width={18} />}
              customStyle={styles.buttonAll}
            />
          </div>
          <div className={styles.mobileButtons}>
            <DropdownComponent
              isCheckbox
              minWidth={162}
              items={sort_items_mapped}
              onSelect={onChangeSort}
              icon={<FilterIcon />}
              customStyle={styles.dropdown}
            />

            <DropdownComponent
              minWidth={162}
              items={download_items_mapped}
              onSelect={handleItemClick}
              icon={<DotsIcon />}
              customStyle={styles.dropdown}
            />
          </div>
        </>
      )}
    </div>
  );
};

DocsTableHeader.propTypes = {
  selected: PropTypes.object,
  setModalOpen: PropTypes.func,
  isDownloading: PropTypes.bool,
  count: PropTypes.number,
  downloadSelected: PropTypes.func,
  onChangeSort: PropTypes.func,
  sort: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default DocsTableHeader;
